"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _antd = require("antd");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var mockVal = function mockVal(str) {
  var repeat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return {
    value: str.repeat(repeat)
  };
};
var Complete = function Complete() {
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var onSearch = function onSearch(searchText) {
    setOptions(!searchText ? [] : [mockVal(searchText), mockVal(searchText, 2), mockVal(searchText, 3)]);
  };
  var onSelect = function onSelect(data) {
    // eslint-disable-next-line no-console
    console.log('onSelect', data);
  };
  var onChange = function onChange(data) {
    setValue(data);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', /*#__PURE__*/_react.default.createElement(_antd.AutoComplete, {
    options: options,
    style: {
      width: 200
    },
    onSelect: onSelect,
    onSearch: onSearch,
    placeholder: "input here"
  }), ' ', /*#__PURE__*/_react.default.createElement("br", null), " ", /*#__PURE__*/_react.default.createElement("br", null), ' ', /*#__PURE__*/_react.default.createElement(_antd.AutoComplete, {
    value: value,
    options: options,
    style: {
      width: 200
    },
    onSelect: onSelect,
    onSearch: onSearch,
    onChange: onChange,
    placeholder: "control mode"
  }), ' ');
};
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(Complete, null);
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: [],
  key: 'autoComplete'
};
var _default = exports.default = componentDemo;